import React from 'react';
import { Header } from '@ui/components/organisms/Header';
import { Footer } from '@ui/components/organisms/Footer';
import { Container } from 'react-bootstrap';
import AppLayoutStyles from './AppLayout.module.scss';

export const AppLayout: React.FC = ({ children }) => {
  return (
    <div className={AppLayoutStyles.app_layout}>
      <Header />
      <Container className={AppLayoutStyles.app_layout__container}>
        <div className={AppLayoutStyles.app_layout__main}>{children}</div>
      </Container>
      <Footer />
    </div>
  );
};
